import React from 'react'
import ContentLoader from 'react-content-loader'

export default function PaymentStatusSkeleton() {
    return (
        <ContentLoader
            speed={2}
            width="100%"
            height={420}
            viewBox="0 0 600 420"
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
        >
            {/* Icon circle */}
            <circle cx="300" cy="60" r="36" />

            {/* Message */}
            <rect x="150" y="120" rx="4" ry="4" width="300" height="16" />

            {/* Payment details title */}
            <rect x="20" y="170" rx="4" ry="4" width="180" height="16" />

            {/* Rows */}
            <rect x="20" y="200" rx="4" ry="4" width="200" height="14" />
            <rect x="380" y="200" rx="4" ry="4" width="200" height="14" />

            <rect x="20" y="230" rx="4" ry="4" width="200" height="14" />
            <rect x="380" y="230" rx="4" ry="4" width="200" height="14" />

            <rect x="20" y="260" rx="4" ry="4" width="200" height="14" />
            <rect x="380" y="260" rx="4" ry="4" width="200" height="14" />

            <rect x="20" y="290" rx="4" ry="4" width="200" height="14" />
            <rect x="380" y="290" rx="4" ry="4" width="200" height="14" />

            {/* Button */}
            <rect x="200" y="350" rx="8" ry="8" width="200" height="36" />
        </ContentLoader>
    )
}
